<template>
  <section>
    <div class="content-wrapper">
      <errors v-if="isVisibleErrorsModal"></errors>
      <address-suggestion v-if="isSuggestedAddressModalVisible"></address-suggestion>
      <div class="content-heading">
        <div v-if="accountType === 'institution'">Create account / Institution account</div>
        <div v-if="accountType === 'trust'">Create account / Trust account</div>
        <small data-localize="dashboard.WELCOME"></small>
      </div>

      <button type="button" class="btn-back icon-back bottom-margin" v-on:click="goBack()">Go back</button>

      <div class="row">
        <spinner v-if="isLoading || userDetailLoading"></spinner>
        <div class="col-lg-8">
          <div id="panelChart9" class="panel panel-default">
            <div class="panel-title">
              <div v-if="accountType === 'institution'">Institution information</div>
              <div v-if="accountType === 'trust'">Trust information</div>
            </div>
            <div class="line-separator"></div>

            <div class="row top-margin">
              <div class="col-md-5">
                <div>
                  <label v-if="accountType === 'institution'">Institution name*</label>
                  <label v-if="accountType === 'trust'">Trust name*</label>
                </div>
              </div>
              <div class="col-md-5 left-margin">
                <div>
                  <label>Tax ID*</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5">
                <div v-if="accountType === 'institution'">
                  <RestrictedSingleInput
                    @inputUpdated="onInstitutionNameUpdate"
                    :input="institutionName"
                    :limit="40"
                    :placeholderText="'Institution name'" />
                  <span
                    v-if="institutionNameChanged && institutionName.trim().length === 0"
                    class="error-feedback"
                  >Required</span>
                </div>
                <div v-if="accountType === 'trust'">
                  <RestrictedSingleInput
                    @inputUpdated="onTrustNameUpdate"
                    :input="trustName"
                    :limit="40"
                    :placeholderText="'Trust name'" />
                  <span
                    v-if="trustNameChanged && trustName.trim().length === 0"
                    class="error-feedback"
                  >Required</span>
                </div>
              </div>
              <div class="col-md-5 left-margin">
                <div>
                  <input name="taxId" id="taxId" type="text" v-model="taxId" class="form-control" placeholder="Tax ID" v-mask="accountType === 'institution' ? '99-9999999' : '999999999'"
                    :class="{ 'form-control': true, 'form-control-error': errors.has('taxId') || isTaxIdInvalid(taxId) }" v-validate="{required: true}" >
                    <span v-if="errors.has('taxId') || isTaxIdInvalid(taxId)" class="error-feedback">Required</span>
                </div>
              </div>
            </div>
            <div class="space" />

            <div class="row top-margin">
              <div class="col-md-5">
                <div>
                  <label v-if="accountType === 'institution'">Institution type*</label>
                  <label v-if="accountType === 'trust'">Trust type*</label>
                </div>
              </div>
              <div class="col-md-5 left-margin">
                <div>
                  <label>Phone number*</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5">
                <div class="form-group" v-if="accountType === 'institution'">
                  <select v-model="institutionTypeSelected" name="institutionType" id="institutionType" required
                    :class="{ 'form-control': true, 'form-control-error': errors.has('institutionType') }" v-validate="{required: true}">
                    <option value="" disabled selected hidden>Institution type</option>
                      <option v-for="(institutionType, index) in institutionTypes"
                        :key="index"
                        :value="institutionType.name">{{institutionType.text}}</option>
                  </select>
                  <span v-if="errors.has('institutionType')" class="error-feedback">Required</span>
                </div>
                <div class="form-group" v-if="accountType === 'trust'">
                  <select v-model="trustTypeSelected" name="trustType" id="trustType" required
                    :class="{ 'form-control': true, 'form-control-error': errors.has('trustType') }" v-validate="{required: true}">
                    <option value="" disabled selected hidden>Trust type</option>
                      <option v-for="(trustType, index) in trustTypes"
                        :key="index"
                        :value="trustType.name">{{trustType.text}}</option>
                  </select>
                  <span v-if="errors.has('trustType')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="row">
              <div class="col-md-5 left-margin">
                <div>
                  <input name="phoneNumber" id="phoneNumber" type="text" v-model="phoneNumber" placeholder="Phone number"
                    :class="{ 'form-control': true, 'form-control-error': errors.has('phoneNumber') || isPhoneNumberInvalid(phoneNumber) }"
                    v-validate="{required: true}" v-mask="'(999) 999-9999'">
                    <span v-if="errors.has('phoneNumber') || isPhoneNumberInvalid(phoneNumber)" class="error-feedback">Required</span>
                </div>
              </div>
            </div>
            </div>
            <div class="space" />

            <div v-if="accountType === 'institution'" class="row top-margin">
              <div class="col-md-5">
                <div>
                  <label>Additional emails for reporting</label>
                </div>
              </div>
            </div>

            <div v-if="accountType === 'institution'"
              class="row bottom-margin"
              v-for="(email, index) in adjacentEmails"
              :key="index">
              <div class="col-md-5">
                <div>
                  <input v-bind:name="'institutionEmail'+index" v-bind:id="'institutionEmail'+index" type="email"
                    v-model="adjacentEmails[index]" class="form-control" placeholder="Email"
                    v-validate="'email'"
                    :class="{ 'form-control': true, 'form-control-error': errors.has('institutionEmail'+index) }">
                  <span v-if="errors.has('institutionEmail'+index)" class="error-feedback">Invalid email format</span>
                </div>
              </div>
              <div class="col-md-5">
                <button v-if="index === 0" type="submit" class="btn btn-info btn-md button-add-more" v-on:click="addEmailSubmit()">Add more</button>
              </div>
            </div>
            <div class="space" />

            <div class="panel-title">
              <div v-if="accountType === 'institution'">Institution address</div>
              <div v-if="accountType === 'trust'">Trust address</div>
            </div>
            <div class="line-separator"></div>

            <div class="row">
              <div class="col-md-10">
                <RestrictedTwoInputs
                  instructionsLabel="Make sure your address doesn't exceed 50 characters."
                  id="ResidentialAddress"
                  fieldLabel="Street address*"
                  primaryPlaceholder="Street and number e.g. 123 Any Street"
                  secondaryPlaceholder="(optional) Building, floor, etc."
                  :dual="true"
                  :primaryInput="residentialAddress.streetAddress1"
                  :secondaryInput="residentialAddress.streetAddress2"
                  @inputUpdated="residentialAddressUpdated"
                 />
              </div>
            </div>
            <div class="space" />

            <div class="row top-margin">
              <div class="col-md-3">
                <div>
                  <label>Zip code*</label>
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <label>City*</label>
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <label>State*</label>
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <label>Country*</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div>
                  <input name="zipCode" id="zipCode" type="text" v-model="residentialAddress.zipCode" class="form-control" placeholder="Zip code"
                    :class="{ 'form-control': true, 'form-control-error': errors.has('zipCode') || isZipCodeInvalid(residentialAddress.zipCode) }" v-validate="{required: true}" >
                    <span v-if="errors.has('zipCode') || isZipCodeInvalid(residentialAddress.zipCode)" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <input name="mainCity" id="mainCity" type="text" v-model="residentialAddress.city" class="form-control" placeholder="City"
                    :class="{ 'form-control': true, 'form-control-error': errors.has('mainCity') }" v-validate="{required: true}" >
                    <span v-if="errors.has('mainCity')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <select v-model="residentialAddress.state" name="state" id="state" required
                    :class="{ 'form-control': true, 'form-control-error': errors.has('state') }" v-validate="{required: true}">
                    <option value="" disabled selected hidden>State</option>
                      <option v-for="(s, index) in countryStates('residentialAddress')" :key="index"
                        :value="s.abbreviation">{{s.name}}</option>
                  </select>
                  <span v-if="errors.has('state')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <select v-model="residentialAddress.country" name="Country" id="Country" required
                    :class="{ 'form-control': true, 'form-control-error': errors.has('Country') }" v-validate="{required: true}">
                      <option value="" disabled selected hidden>Country</option>
                      <option v-for="(c, index) in geoLocation.countries" :key="index"
                        :value="c.abbreviation">{{c.name}}</option>
                  </select>
                  <span v-if="errors.has('country')" class="error-feedback">Required</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="checkbox c-checkbox check-margin">
                  <label>
                    <input type="checkbox" value="" name="hasDifferentMailingAddress"
                      v-model="hasDifferentMailingAddress" v-on:click="submitDifferentMailingAddress()">
                    <span class="fa fa-check">
                    </span>Different mailing address
                  </label>
                </div>
              </div>
            </div>

            <div class="panel-title">
              <div>Mailing address</div>
            </div>
            <div class="line-separator"></div>

            <div class="row">
              <div class="col-md-10">
                <RestrictedTwoInputs
                  instructionsLabel="Make sure your address doesn't exceed 50 characters."
                  id="MailingAddress"
                  fieldLabel="Street address*"
                  primaryPlaceholder="Street and number e.g. 123 Any Street"
                  secondaryPlaceholder="(optional) Building, floor, etc."
                  :dual="true"
                  :primaryInput="mailingAddress.streetAddress1"
                  :secondaryInput="mailingAddress.streetAddress2"
                  @inputUpdated="mailingAddressUpdated"
                  :isDisabled="!hasDifferentMailingAddress"
                 />
              </div>
            </div>
            <div class="space" />

            <div class="row top-margin">
              <div class="col-md-3">
                <div>
                  <label>Zip code*</label>
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <label>City*</label>
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <label>State*</label>
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <label>Country*</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div>
                  <input v-bind:disabled="!hasDifferentMailingAddress" name="mailingZipCode" id="mailingZipCode" type="text" v-model="mailingAddress.zipCode" class="form-control" placeholder="Zip code"
                    :class="{ 'form-control': true, 'form-control-error': (hasDifferentMailingAddress && errors.has('mailingZipCode')) || isZipCodeInvalid(mailingAddress.zipCode) }" v-validate="{required: true}" >
                    <span v-if="hasDifferentMailingAddress && (errors.has('mailingZipCode') || isZipCodeInvalid(mailingAddress.zipCode))" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <input v-bind:disabled="!hasDifferentMailingAddress" name="mailingCity" id="mailingCity" type="text" v-model="mailingAddress.city" class="form-control" placeholder="City"
                    :class="{ 'form-control': true, 'form-control-error': hasDifferentMailingAddress && errors.has('mailingCity') }" v-validate="{required: true}" >
                    <span v-if="hasDifferentMailingAddress && errors.has('mailingCity')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <select v-bind:disabled="!hasDifferentMailingAddress" v-model="mailingAddress.state" name="mailingState" id="mailingState" required
                    :class="{ 'form-control ': true, 'form-control-error': hasDifferentMailingAddress && errors.has('mailingState'), 'disabled-state': !hasDifferentMailingAddress }" v-validate="{required: true}">
                    <option value="" disabled selected hidden>State</option>
                      <option v-for="(s, index) in countryStates('mailingAddress')"
                        :value="s.abbreviation" :key="index">{{s.name}}</option>
                  </select>
                  <span v-if="hasDifferentMailingAddress && errors.has('mailingState')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <select v-bind:disabled="!hasDifferentMailingAddress" v-model="mailingAddress.country" name="Country" id="Country" required
                    :class="{ 'form-control': true, 'form-control-error': errors.has('Country'), 'disabled-state': !hasDifferentMailingAddress }" v-validate="{required: true}">
                      <option value="" disabled selected hidden>Country</option>
                      <option v-for="(c, index) in geoLocation.countries" :key="index"
                        :value="c.abbreviation">{{c.name}}</option>
                  </select>
                  <span v-if="errors.has('country')" class="error-feedback">Required</span>
                </div>
              </div>
            </div>
            <div class="space" />

            <div class="panel-title">
              <div v-if="accountType === 'institution'">Documentation of authorized signers</div>
              <div v-if="accountType === 'trust'">Trust document</div>
            </div>
            <div class="line-separator"></div>

            <div class="upload-container" :class="{ 'has-error': isFileInvalid }">
              <div class="bottom-margin">
                <input @change="fileChanged" type="file" data-classbutton="btn btn-default" data-classinput="form-control inline"
                  class="form-control filestyle" id="filestyle-0" tabindex="-1" style="position: absolute; clip: rect(0px 0px 0px 0px);"
                  :accept="getAcceptedFileExtensions()" ref="fileupload">
                <div class="bootstrap-filestyle input-group">
                  <input type="text" class="form-control " placeholder="" disabled="" :value="selectedFile ? selectedFile.name : ''">
                  <span class="group-span-filestyle input-group-btn" tabindex="0">
                    <label for="filestyle-0" class="btn btn-default document-label">
                      <span class="icon-span-filestyle fa fa-folder-open"></span>
                      <span class="buttonText">Choose file</span>
                    </label>
                  </span>
                </div>
              </div>
              <span class="help-block">Your file must be in JPG, JPEG, PNG, TIF or PDF format and cannot exceed 10MB.</span>
              <span v-if="isFileInvalid" class="help-block m-b-none">The file you selected is not valid. Please select a different file.</span>
            </div>

            <div v-if="uploadedFiles.length > 0" class="space table-responsive">
              <table class="table table-striped table-files">
                <thead>
                  <tr>
                    <th class="text-center">File name</th>
                    <th class="text-center">Uploaded by</th>
                    <th class="text-center">Date</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(file, index) in uploadedFiles" :key="index">
                    <td class="text-center">{{file.name}}</td>
                    <td class="text-center">{{`${user.firstName} ${user.lastName}`}}</td>
                    <td class="text-center">{{formatDate(new Date())}}</td>
                    <td class="text-center">
                      <a class="text-red" href="#" @click.prevent="removeDocument(index)">
                        <em class="fa fa-trash" ></em></a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="space" />
            </div>

            <div class="panel-title space">
              <div>Payment preference</div>
            </div>
            <div class="line-separator"></div>

            <div class="row top-margin">
                <div class="col-md-5">
                  <div>
                    <label>Principal maturity preference*</label>
                  </div>
                </div>
                <div class="col-md-5 left-margin">
                  <div>
                    <label>Interest payment preference*</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5">
                  <div class="form-group">
                    <select v-model="principalPaymentSelected" name="principalPayment" id="principalPayment" required
                      :class="{ 'form-control': true, 'form-control-error': errors.has('principalPayment') }" v-validate="{required: true}">
                      <option value="" disabled selected hidden>Select principal payment preference</option>
                        <option v-for="(principal, index) in paymentPreference"
                          :key="index"
                          :value="principal.name">{{principal.text}}</option>
                    </select>
                    <span v-if="errors.has('principalPayment')" class="error-feedback">Required</span>
                  </div>
                </div>
                <div class="col-md-5 left-margin">
                  <div class="form-group">
                    <select v-model="interestPaymentSelected" name="interestPayment" id="interestPayment" required
                      :class="{ 'form-control': true, 'form-control-error': errors.has('interestPayment') }" v-validate="{required: true}">
                      <option value="" disabled selected hidden>Select interest payment preference</option>
                        <option v-for="(interest, index) in paymentPreference"
                          :key="index"
                          :value="interest.name">{{interest.text}}</option>
                    </select>
                    <span v-if="errors.has('interestPayment')" class="error-feedback">Required</span>
                  </div>
                </div>
              </div>
            <div class="line-separator top-margin"></div>

            <div class="row top-margin">
              <div class="col-md-10">
                  <button type="submit" class="btn btn-info btn-lg button-approve" v-bind:disabled="isSubmitButtonDisabled(errors)" v-on:click="submitRequest()">Submit</button>
              </div>
            </div>
            <div class="line-separator top-margin"></div>
            <button type="button" class="btn-back icon-back bottom-margin" v-on:click="goBack()">Go back</button>
            <div class="space" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState,
  } from 'vuex';

  import * as EmailValidator from 'email-validator';

  import { filter } from 'lodash';

  import Errors from '@/components/modals/Errors';
  import addressSuggestion from '@/components/modals/AddressSuggestion';
  import institutionTypes from '@/data/static/institutionTypes'; // eslint-disable-line no-unused-vars
  import trustTypes from '@/data/static/trustTypes'; // eslint-disable-line no-unused-vars
  import paymentPreferenceAction from '@/data/static/upcomingTransactionActions'; // eslint-disable-line no-unused-vars
  import RestrictedTwoInputs from '@/components/formControls/RestrictedTwoInputs';
  import { UserTypes } from '@/data/static/userTypes';
  import ProhibitedStates from '@/data/static/reinvestProhibitedStates';
  import RestrictedSingleInput from '@/components/formControls/RestrictedSingleInput';

  import {
    SET_ERRORS_MODAL_INFO,
    SHOW_ERRORS_MODAL,
    SET_SUGGESTED_ADDRESS,
    SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
    SET_SUGGESTED_ADDRESS_TYPE,
    SET_SUGGESTED_ADDRESS_YES_METHOD,
  } from '@/store/mutation-types';

  import { formatDate, zipRegex } from '@/util';
  import spinner from '@/components/widgets/Spinner';

  import {
    AddressErrors,
  } from '../data/static/addressErrors';

  const mix = {
    methods: {
      formatDate,
    },
  };

  const acceptedFileExtensions = [
    'png',
    'jpg',
    'jpeg',
    'tif',
    'pdf',
  ];

  const MAX_FILE_SIZE = 10485760;

  export default {
    name: 'accountCreationInstitutionTrust',
    beforeMount() {
      this.initializeState();
    },
    components: {
      spinner,
      RestrictedTwoInputs,
      RestrictedSingleInput,
      errors: Errors,
      'address-suggestion': addressSuggestion,
    },
    mixins: [mix],
    data() {
      return {
        name: '',
        userId: '',
        accountId: '',
        accountType: '',
        accountName: '',
        user: {},
        institutionName: '',
        trustName: '',
        taxId: '',
        institutionTypeSelected: '',
        institutionTypes: [],
        trustTypeSelected: '',
        trustTypes: [],
        phoneNumber: '',
        residentialAddress: {
          streetAddress1: '',
          streetAddress2: '',
          zipCode: '',
          city: '',
          state: '',
          country: '',
        },
        mailingAddress: {
          streetAddress1: '',
          streetAddress2: '',
          zipCode: '',
          city: '',
          state: '',
          country: '',
        },
        hasDifferentMailingAddress: false,
        isFileInvalid: false,
        uploadFailed: false,
        uploadSucceeded: false,
        selectedFile: null,
        uploadedFiles: [],
        adjacentEmails: [''],
        interestPayment: '',
        principalPayment: '',
        isLoading: false,
        userDetailLoading: false,
        institutionNameChanged: false,
        trustNameChanged: false,
      };
    },
    computed: {
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapState('app', [
        'geoLocation',
      ]),
      ...mapState('accountCreation', [
        'isSuggestedAddressModalVisible',
        'suggestedAddressModalYesCall',
      ]),
      isFromProhibitedState() {
        return ProhibitedStates.find(s => s === this.residentialAddress.state) !== undefined;
      },
      paymentPreference() {
        return this.isFromProhibitedState
        ? [
          paymentPreferenceAction.cashout,
          paymentPreferenceAction.donate,
        ] : [
          paymentPreferenceAction.reinvest,
          paymentPreferenceAction.donate,
          paymentPreferenceAction.cashout,
        ];
      },
      interestPaymentSelected: {
        get() {
          return this.interestPayment ? this.interestPayment : this.paymentPreference[0].name;
        },
        set(preference) {
          this.interestPayment = preference;
        },
      },
      principalPaymentSelected: {
        get() {
          return this.principalPayment ? this.principalPayment : this.paymentPreference[0].name;
        },
        set(preference) {
          this.principalPayment = preference;
        },
      },
    },
    watch: {
      // eslint-disable-next-line no-unused-vars
      async suggestedAddressModalYesCall({ _, suggestedAddress, addressType }) {
        if (!this.hasDifferentMailingAddress) {
          this.residentialAddress = suggestedAddress;
          this.mailingAddress = suggestedAddress;
        }
        if (['organization'].includes(addressType)) {
          this.residentialAddress = suggestedAddress;
        } else if (addressType === 'mailing') {
          this.mailingAddress = suggestedAddress;
        }
        await this.submitRequest();
      },
    },
    methods: {
      ...mapActions('accountCreation', [
        'createOrganizationAccount',
        'createAccountDocuments',
        'putDocumentToS3',
        'createAccountByAdmin',
        'createOrganizationByAdmin',
        'verifyOrganizationAddress',
        'verifyMailingAddress',
        'getUserDetail',
      ]),
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      ...mapMutations('accountCreation', {
        setSuggestedAddress: SET_SUGGESTED_ADDRESS,
        setSuggestedAddressType: SET_SUGGESTED_ADDRESS_TYPE,
        setSuggestedAddressModalVisible: SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
        setSuggestedAddressYesMethod: SET_SUGGESTED_ADDRESS_YES_METHOD,
      }),
      countryStates(address) {
        if (this[address].country === this.geoLocation.countries[0].abbreviation) {
          if (address !== 'mailingAddress') {
            return this.geoLocation.states.filter(state => !state.onlyMailingAddress);
          }
          return this.geoLocation.states;
        }
        return this.geoLocation.canadaStates;
      },
      truncateAddressIfNecessary(address) {
        const localAddress = { ...address };
        const hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
        const hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
        if (hasStreetAddress1 && hasStreetAddress2) {
          const totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
          if (totalAdressLength > 50) {
            const charsToCut = totalAdressLength - 50;
            localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
            return localAddress;
          }
        }
        return address;
      },
      residentialAddressUpdated($event) {
        this.residentialAddress.streetAddress1 = $event.primary;
        this.residentialAddress.streetAddress2 = $event.secondary;
      },
      mailingAddressUpdated($event) {
        this.mailingAddress.streetAddress1 = $event.primary;
        this.mailingAddress.streetAddress2 = $event.secondary;
      },
      initializeState() {
        this.isLoading = true;
        this.userId = Number(sessionStorage.getItem('searchedUser'));
        this.name = this.$route.params.name;
        this.accountId = this.$route.params.accountId;
        this.accountType = sessionStorage.getItem('accountTypeToCreate');
        this.institutionTypes = Object.keys(institutionTypes).map(
          key => institutionTypes[key],
        );
        this.trustTypes = Object.keys(trustTypes).map(
          key => trustTypes[key],
        );
        this.isLoading = false;
        this.loadUserDetail();
      },
      async loadUserDetail() {
        this.isLoading = true;
        await this.getUserDetail(this.userId).then((data) => {
          this.user = Object.assign({}, data);
          if (this.geoLocation.countries && this.geoLocation.countries.length > 0) {
            this.residentialAddress.country = this.geoLocation.countries[0].abbreviation;
            this.mailingAddress.country = this.geoLocation.countries[0].abbreviation;
          }
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
      },
      async submitRequest() {
        try {
          this.isLoading = true;

          const accountObject = {
            paymentPreference: this.principalPaymentSelected,
            interestPreference: this.interestPaymentSelected,
            emails: this.getValidEmails(this.adjacentEmails),
            // The address are only sent to verification proposes
            address: this.residentialAddress,
            mailingAddress: this.hasDifferentMailingAddress ?
            this.mailingAddress : this.residentialAddress,
          };

          if (this.accountType.includes('trust')) {
            accountObject.accountType = 'TRUST';
            accountObject.accountName = this.trustName;
          } else if (this.accountType.includes('institution')) {
            accountObject.accountType = 'INSTITUTION';
            accountObject.accountName = this.institutionName;
          }

          accountObject.documents = this.uploadedFiles.map((file) => {
            const { name, size, type } = file;

            return {
              mimetype: type,
              originalName: name,
              size,
            };
          });

          const { documents, accountId } = await this.createAccountByAdmin({
            userId: this.userId,
            accountObject,
          });

          const organizationObject = {
            taxId: this.removeHypens(this.taxId),
            phoneNumber: this.getPhoneDigits(this.phoneNumber),
            mainAddress: this.residentialAddress,
            mailingAddress: this.hasDifferentMailingAddress ?
            this.mailingAddress : this.residentialAddress,
            hasDifferentMailingAddress: this.hasDifferentMailingAddress,
          };

          if (this.accountType.includes('trust')) {
            organizationObject.type = trustTypes[this.trustTypeSelected].key;
            organizationObject.name = this.trustName;
          } else if (this.accountType.includes('institution')) {
            organizationObject.type = institutionTypes[this.institutionTypeSelected].key;
            organizationObject.name = this.institutionName;
          }

          let uploadedDocuments = [];

          if (documents.length) {
            uploadedDocuments = await Promise.all(documents.map(async (doc) => {
              const file = this.uploadedFiles.find(f => decodeURIComponent(doc.url).includes(f.name));

              await this.putDocumentToS3({ presignedUrl: doc.url, file });
              return {
                mimetype: file.type,
                size: file.size,
                originalName: file.originalName,
                filename: doc.filename,
              };
            }));
          }

          await this.createAccountDocuments({
            accountId,
            files: { documents: uploadedDocuments },
          });

          await this.createOrganizationByAdmin({
            organizationObject,
            accountId,
          });

          this.isLoading = false;
          this.goBack();
        } catch (error) {
          this.isLoading = false;
        }
      },
      displayModalWithErrorMessages(error) {
        if (!error || !error.message) {
          this.setErrorsModalInfo(['Something wrong happened. Please try again or contact Calvert support.']);
        } else if (AddressErrors[error.message]) {
          this.setErrorsModalInfo([AddressErrors[error.message]]);
        } else {
          this.setErrorsModalInfo(error.message.split(','));
        }
        this.showErrorsModal();
      },
      addEmailSubmit() {
        this.adjacentEmails.push('');
      },
      submitDifferentMailingAddress() {
        this.mailingAddress.streetAddress1 = '';
        this.mailingAddress.streetAddress2 = '';
        this.mailingAddress.zipCode = '';
        this.mailingAddress.city = '';
        this.mailingAddress.state = '';
      },
      fileChanged({ target: { files } }) {
        this.isLoading = true;
        this.isFileInvalid = false;
        if (files.length) {
          const selectedFile = files[0];
          const extension = selectedFile.name.split('.').pop().toLowerCase();
          const { size } = selectedFile;
          if (acceptedFileExtensions.indexOf(extension) === -1 || size > MAX_FILE_SIZE) {
            this.isFileInvalid = true;
            this.selectedFile = null;
          } else {
            this.selectedFile = null;
            this.selectedFile = selectedFile;
            this.uploadedFiles.push(this.selectedFile);
          }
        }
        this.isLoading = false;
      },
      removeDocument(index) {
        if (index > -1) {
          this.uploadedFiles.splice(index, 1);
          this.selectedFile = null;
          const input = this.$refs.fileupload;
          input.type = 'text';
          input.type = 'file';
        }
      },
      getAcceptedFileExtensions() {
        return acceptedFileExtensions.map(ext => `.${ext}`).join(',');
      },
      getValidEmails(emails) {
        const validEmails = emails.filter(email => EmailValidator.validate(email));
        return validEmails;
      },
      getPhoneDigits(phoneNum) {
        return phoneNum.replace(/[-() ]/g, '');
      },
      removeHypens(text) {
        return text.replace(/[-]/g, '');
      },
      isPhoneNumberInvalid(phoneNumber) {
        if (!phoneNumber) {
          return false;
        }
        const phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
        return !phoneRegex.test(phoneNumber);
      },
      isTaxIdInvalid(taxId) {
        if (!taxId) {
          return false;
        }
        const taxIdRegex = /^\d{2}?[- ]?\d{7}$/;
        return !taxIdRegex.test(taxId);
      },
      isZipCodeInvalid(zipCode) {
        if (!zipCode) {
          return false;
        }
        return !zipRegex.test(zipCode);
      },
      requiredFieldsContainEmpty() {
        if (this.accountType === 'institution') {
          if (!this.institutionName) {
            return true;
          }
          if (!this.institutionTypeSelected) {
            return true;
          }
        } else {
          if (!this.trustName) {
            return true;
          }
          if (!this.trustTypeSelected) {
            return true;
          }
        }
        if (!this.taxId) {
          return true;
        }
        if (!this.phoneNumber) {
          return true;
        }
        if (!this.residentialAddress.streetAddress1) {
          return true;
        }
        if (!this.residentialAddress.zipCode) {
          return true;
        }
        if (!this.residentialAddress.city) {
          return true;
        }
        if (!this.residentialAddress.state) {
          return true;
        }
        if (!this.interestPaymentSelected) {
          return true;
        }
        if (!this.principalPaymentSelected) {
          return true;
        }
        if (this.hasDifferentMailingAddress) {
          if (!this.mailingAddress.streetAddress1) {
            return true;
          }
          if (!this.mailingAddress.zipCode) {
            return true;
          }
          if (!this.mailingAddress.city) {
            return true;
          }
          if (!this.mailingAddress.state) {
            return true;
          }
        }
        return false;
      },
      isSubmitButtonDisabled(errors) {
        const cleanedErrors = filter(errors.items, (item) => {
          if (this.hasDifferentMailingAddress
            && (item.field === 'mailingStreetAddress1' || item.field === 'mailingZipCode'
            || item.field === 'mailingCity' || item.field === 'mailingState')) {
            return item;
          } else if (item.field !== 'mailingStreetAddress1' && item.field !== 'mailingZipCode'
            && item.field !== 'mailingCity' && item.field !== 'mailingState') {
            return item;
          }
          return false;
        });
        if (cleanedErrors.length > 0) {
          return true;
        }
        if (this.requiredFieldsContainEmpty()) {
          return true;
        }
        if (this.isPhoneNumberInvalid(this.phoneNumber)) {
          return true;
        }
        if (this.isTaxIdInvalid(this.taxId)) {
          return true;
        }
        if (this.isZipCodeInvalid(this.residentialAddress.zipCode)) {
          return true;
        }
        if (this.hasDifferentMailingAddress
          && (this.isZipCodeInvalid(this.mailingAddress.zipCode))) {
          return true;
        }
        return false;
      },
      goBack() {
        const name = this.name;
        const userId = this.userId;
        if (this.user.userType === UserTypes.FINANCIAL_ADVISOR.name) {
          this.$router.push({ name: 'EditUserFinancial', params: { name, userId } });
        } else {
          this.$router.push({ name: 'UserDetail', params: { name, userId } });
        }
      },
      onInstitutionNameUpdate(value) {
        this.institutionNameChanged = true;
        this.institutionName = value.trim();
      },
      onTrustNameUpdate(value) {
        this.trustNameChanged = true;
        this.trustName = value.trim();
      },
    },
  };
</script>

<style scoped>
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
  .left-margin {
    margin-left: 4%;
  }
  .right-margin {
    margin-left: -4%;
  }
  .top-margin {
    margin-top: 2%;
  }
  .bottom-margin {
    margin-bottom: 2%;
  }
  .space {
    margin-top: 4%;
  }
  .content-heading {
    font-weight: normal;
  }
  .upload-container {
    height: 80px;
    padding-top: 10px;
  }
  .panel-title {
    font-size: 20px;
  }
  .panel-subtitle {
    font-size: 16px;
  }
  .panel-default {
    padding: 30px 40px;
    width: 750px;
  }
  .panel-heading {
    background-color: #ffffff;
    font-size: 16px;
    padding: 0px 5px;
  }
  .document-label {
    width: 120px;
  }
  label {
    color: #888;
    font-size: 14px;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
  }
  select:required:invalid {
  color: lightgray;
  }
  option[value=""][disabled] {
    display: none;
  }
  option {
    color: black;
  }
  .total-amount {
    font-size: 20px;
  }
  .button-add-more {
    background-color: #127285;
  }
  .button-approve {
    background-color: #127285;
  }
  .button-white {
    background-color: white;
    border-color: #127285;
    color: #127285;
  }
  .btn-back {
    color: #31b0d5;
    background-color: Transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    padding-left: 20px;
  }
  .icon-back {
    position: relative;
  }
  .icon-back:before {
    content: "\f060";
    font-family: FontAwesome;
    position: absolute;
    left: 0px;
  }
  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: lightgray;
    opacity: 1; /* Firefox */
  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: lightgray;
  }
  ::-ms-input-placeholder { /* Microsoft Edge */
      color: lightgray;
  }
  .table-files {
    width: 90%;
  }
  .disabled-state {
    color: #ccc;
  }
  .text-red {
    color: #a94442;
  }
</style>



// WEBPACK FOOTER //
// AccountCreationOrganization.vue?62c84110